<template>
  <div class="c-float table-th relative">
    <!-- CHECKBOX -->
    <div v-if="checkbox" class="table-cell small">
      <Checkbox
        v-model="checked"
        @change="onChange"/>
    </div>
    <!-- TYPE -->
    <div v-if="type.type" class="table-cell small">
      <p><span class="main-info">{{ type.text }}</span></p>
    </div>
    <!-- IMAGE -->
    <div v-if="type.image" class="table-cell small">
      <p><span class="main-info">{{ $t('Image') }}</span>
        <span class="additional-info">&nbsp;</span>
      </p>
    </div>
    <!-- Dynamic data -->
    <div
      class="table-cell"
      v-for="(optionItem, index) in computedData"
      :key="`th-${index}`">
      <p>
        <span
          :class="index === 0 ? 'main-info' : 'additional-info'"
          v-for="(value, key, index) in optionItem"
          :key="`span-${index}`">
           {{ value }}
        </span>
      </p>
    </div>
    <div v-if="detailView" class="table-cell x-small text-center">
      <p><span class="main-info"></span></p>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import Checkbox from '@/components/elements/inputs/checkbox.vue';
export default {
  name: 'TableHeader',
  props: ['data', 'checkbox', 'type', 'checked', 'detailView'],
  components: {
    Checkbox,
  },
  computed: {
    computedData() {
      const data = [];
      this.data.forEach(item => {
        const cleanedObject = Object.fromEntries(Object.entries(item).filter(([key]) => !key.includes('formatter')));
        data.push(cleanedObject);
      });
      return data;
    }
  },
  data() {
    return {
      selectionExist: false,
    };
  },
  methods: {
    onChange(){
      this.$emit('selectAll');
    },
  },
}
</script>
